import { render, staticRenderFns } from "./charmImpr.vue?vue&type=template&id=4f1e076a"
import script from "./charmImpr.vue?vue&type=script&lang=js"
export * from "./charmImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f1e076a')) {
      api.createRecord('4f1e076a', component.options)
    } else {
      api.reload('4f1e076a', component.options)
    }
    module.hot.accept("./charmImpr.vue?vue&type=template&id=4f1e076a", function () {
      api.rerender('4f1e076a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/charm/risk/charmImpr.vue"
export default component.exports